<template>
  <section class="h-100">

    <div class="m-auto text-center mb-7">
      <img
        src="@/assets/images/menu_2.svg"
        class="w-full"
      >

      <img
        src="@/assets/images/setup_profile/step_3.svg"
        class="mx-auto mt-5"
      >
      <span class="text-neutral">Step 3 of 10</span>
    </div>

    <div class="flex h-screen text-center" style="height: 80vh;">
      <div class="m-auto pb-10 w-2/3">

        <div class="mt-9">
          <h3 class="text text-center text-black mb-4">
            {{ firstName }}'s Experience
          </h3>

          <a href="#" class="text-primary font-bold">Where did you get this information?</a>
        </div>

        <div v-if="!editable">

          <div class="grid grid-cols-1 justify-center content-center place-items-center mt-10 mb-16">

            <div class="content flex py-2 text-left w-3/4 mb-10" v-for="experience in experiences" :key="experience.id">
              <img
                :src="require(`@/assets/images/company_1.png`)"
                class="w-12 h-12"
              >
              <div class="item-body px-2 relative w-full">
                <span class="text text-black font-bold block mb-1">
                  {{ experience.title }}

                  <a href="#" @click="changeMode()" class="absolute right-0">
                    <img
                      src="@/assets/images/icons/ic_edit.svg"
                    >
                  </a>
                </span>

                <span class="text text-primary block mb-1">
                  {{ experience.company_name }}
                </span>

                <span class="text text-black block mb-1" v-if="experience.currently_working">
                  {{ experience.currently_working ? 'Since' : '' }} {{ experience.start_date }}
                </span>

                <span class="text text-black block mb-1" v-if="!experience.currently_working">
                  {{ getStringDate(experience.start_date) }} • {{ getStringDate(experience.end_date) }}
                </span>

                <span class="text text-neutral block mb-1">
                  {{ experience.description }}
                </span>

                <div class="mt-4">
                  <span class="tag-gray" v-for="tag in experience.tags" :key="tag.id">{{ tag.title }}</span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <router-link
              :to="{name: 'v2.profile.about'}"
              class="text-primary float-left"
            >
              <img
                src="@/assets/images/icons/ic_chevron_left_blue.svg"
                class="inline"
              >
              Back
            </router-link>

            <a
              class="btn btn-primary-outline btn-large align-self-center me-auto mr-5"
              @click="changeMode()"
            >
              Edit
            </a>

            <router-link
              :to="{name: 'v2.profile.education'}"
              class="btn btn-primary btn-large align-self-center me-auto"
            >
              Looks Good!
            </router-link>

            <router-link
              :to="{name: 'v2.profile.education'}"
              class="text-primary float-right"
            >
              Skip

              <img
                src="@/assets/images/icons/ic_chevron_right_blue.svg"
                class="inline"
              >
            </router-link>
          </div>
        </div>

        <div v-if="editable">
          <form
            class="mt-10 mb-10"
            @submit.prevent="register"
          >

            <div
              v-if="errorMessage"
              class="flex items-center text-dark text-sm mb-5 alert-error"
              role="alert"
            >
              <img
                src="@/assets/images/ic_danger.svg"
                class="mr-2"
              >
              <p>{{ errorMessage }}</p>
            </div>

            <div class="mb-10">
              <div class="form-check w-1/2 inline-block text-right">
                <label class="form-check-label" for="flexCheckIndeterminate">
                  Show
                </label>

                <label class="switch">
                  <input type="checkbox" checked>
                  <span class="slider round"></span>
                </label>
              </div>
            </div>

            <div class="mb-10">
              <input
                v-model="title"
                type="text"
                class="form-control"
                placeholder="Title"
                style="width: 23.3%;margin-right: 40px;"
                required
              >

              <input
                v-model="companyName"
                type="text"
                class="form-control w-1/4"
                placeholder="Company Name"
                style="width: 23.3%;"
                required
              >
            </div>

            <div class="mb-10">
              <input
                v-model="startDate"
                type="text"
                class="form-control"
                placeholder="Start Date"
                style="width: 23.3%;margin-right: 40px;"
                required
              >

              <input
                v-model="endDate"
                type="text"
                class="form-control w-1/4"
                placeholder="End Date"
                style="width: 23.3%;"
                required
              >
            </div>

            <div class="mb-10">
              <div class="form-check w-1/2 inline-block">
                <label class="form-check-label text-neutral float-left" for="flexCheckIndeterminate">
                  I currently work here
                </label>

                <label class="switch float-right">
                  <input type="checkbox" checked>
                  <span class="slider round"></span>
                </label>
              </div>
            </div>

            <div class="mb-6">
              <textarea
                v-model="description"
                rows="4"
                cols="10"
                class="w-1/2 p-2"
                placeholder="Description"
              ></textarea>
            </div>

            <div>
              <textarea
                v-model="areaFocus"
                rows="2"
                cols="10"
                class="w-1/2 p-2"
                placeholder="What are/were your primary areas of focus during this experience?"
              ></textarea>
            </div>
          </form>

          <div class="mb-10">
            <a
              href="#"
              class="text-primary align-self-center me-auto"
            >
              Add Another

              <img
                src="@/assets/images/icons/ic_plus.svg"
                class="inline-block"
              >
            </a>
          </div>

          <div>
            <router-link
              :to="{name: 'v2.profile.about'}"
              class="text-primary float-left"
            >
              <img
                src="@/assets/images/icons/ic_chevron_left_blue.svg"
                class="inline"
              >
              Back
            </router-link>

            <a
              href="#"
              @click="changeMode()"
              class="btn btn-primary-outline btn-large align-self-center me-auto mr-5"
            >
              Finish Later
            </a>

            <a
              href="#"
              @click="submit()"
              class="btn btn-primary btn-large align-self-center me-auto"
            >
              Onwards
            </a>

            <router-link
              :to="{name: 'v2.profile.education'}"
              class="text-primary float-right"
            >
              Skip

              <img
                src="@/assets/images/icons/ic_chevron_right_blue.svg"
                class="inline"
              >
            </router-link>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Experience',
  data() {
    return {
      firstName: '',
      title: '',
      companyName: '',
      startDate: '',
      endDate: '',
      description: '',
      areaFocus: '',
      errorMessage: null,
      editable: false,
      experiences: [],
      uuid: null
    };
  },
  methods: {
    changeMode: function() {
      this.editable = !this.editable;
    },
    getStringDate: function(date) {
      let dateObj = new Date(date);
      if (dateObj == 'Invalid Date') {
        return 'Aug 2020';
      }

      return dateObj.toLocaleString('en-us',{month:'short', year:'numeric'});
    },
    getExperiences() {
      axios.get(process.env.VUE_APP_API_URL + '/attributes/experience/' + this.uuid, {
        headers: {
          'Authorization': `Bearer`
        }
      })
      .then((response) => {
        this.experiences = response.data.attributes;
      })
      .catch((error) => {
        console.log(error);
      });
    },
    submit() {
      let data = {
        uuid: this.uuid,
        node_type: 'experience',
        attributes: {
          title: this.title,
          company_name: this.companyName,
          start_date: this.startDate,
          end_date: this.endDate,
          description: this.description,
          area_focus: this.areaFocus
        }
      };

      axios.post(process.env.VUE_APP_API_URL + '/attribute', data, {
        headers: {
          'Authorization': `Bearer`
        },
      })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
    },
    update() {
      let data = {
        uuid: '59e8f824-e6a1-45e4-b70a-b541d2f495da',
        attributes: {
          title: this.title,
          company_name: this.companyName,
          start_date: this.startDate,
          end_date: this.endDate,
          description: this.description,
          area_focus: this.areaFocus
        }
      };

      axios.patch(process.env.VUE_APP_API_URL + '/attribute', data, {
        headers: {
          'Authorization': `Bearer`
        },
      })
      .then((response) => {
        console.log(response);

        this.changeMode();
        this.getExperiences();
      })
      .catch((error) => {
        console.log(error);
      });
    }
  },
  mounted() {
    let firstName = localStorage.getItem('preferredname');
    this.uuid = localStorage.getItem('userUuid');

    if (firstName && firstName !== '') {
      this.firstName = firstName;
    }

    this.getExperiences();
  }
}
</script>

<style scoped>
h3 {
  font-family: 'Helvetica';
  font-size: 30px;
  line-height: 32px;
  letter-spacing: 1px;
  font-weight: bold;
}
h3 > strong {
  font-weight: bold;
}
</style>
